var $ = require("jquery");

// Sets elements corresponding to a given css selector to a uniform
// height, determined by the maximum height from the selected set.

/**
 * Sets elements corresponding to a given CSS selector to a uniform
 * height, determined by the maximum height from the selected set.
 *
 * Warning: Static heights can cause major UI issues, especially when
 * dealing with multiple rows of content. Please make sure there are no other
 * options before using this function.
 *
 * @param {string} selector jQuery selector
 */
var setUniformHeight = function(selector) {
    var maxHeight = 0;
    $(selector).each(function() {
        maxHeight = Math.max(maxHeight, $(this).height());
    }).height(maxHeight);
};

/**
 * Searches DOM for selector, checks for overflowing text
 * and replaces tail with ellipses.
 *
 * @param {string} selector jQuery selector
 */
var ellipsify = function(selector) {
    $(selector).each(function() {
        var $ellipsisText = $(this);
        var textContainerHeight = $ellipsisText.closest('.box__content').height();
        while ($ellipsisText.closest('.text_container').outerHeight() > textContainerHeight) {
            var text = $ellipsisText.text();
            if(text.match(/\W*\s(\S)*$/)) {
                $ellipsisText.text(text.replace(/\W*\s(\S)*$/, "..."));
            } else {
                break;
            }
        }
    });
};

exports.setUniformHeight = setUniformHeight;
exports.ellipsify = ellipsify;



//////////////////
// WEBPACK FOOTER
// ../~/poly-js-utils/src/element-helpers.js
// module id = 167
// module chunks = 0